import { Component, OnInit, ViewChild, ChangeDetectorRef, HostListener } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { HttpService } from '../shared/services/http.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { ControllerService } from '../shared/services/controller.service';

@Component({
  selector: 'app-code',
  templateUrl: './code.component.html',
  styleUrls: ['./code.component.scss'],
  standalone: false
})
export class CodeComponent implements OnInit {

  codes: any = [];
  dataSource: any

  library: any = []

  activeMenuId: number | null = null; // Track open menu
  menuTimeout: any;

  // Close menu on document click
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    this.activeMenuId = null;
  }

  toggleMenu(id: number, event: MouseEvent) {
    event.stopPropagation();
    if (this.activeMenuId === id) {
      this.activeMenuId = null;
    } else {
      this.activeMenuId = id;
    }
  }

  onMouseLeave() {
    this.menuTimeout = setTimeout(() => {
      this.activeMenuId = null;
    }, 150);
  }

  onMouseEnter(id) {
    if (this.activeMenuId !== id) return;

    if (this.menuTimeout) {
      clearTimeout(this.menuTimeout);
      this.menuTimeout = null;
    }
  }

  shareUserGuides = false

  fromDate = null

  displayCsmReport = false
  csmReportDescription = ""

  schedule: any = []
  scheduleDataSource: any

  filterDebounce: any

  clientName = ''

  clientKind = ''

  contractEndDate = ''

  code: any

  displayedColumns: string[] = [];
  @ViewChild(MatSort, { static: true }) sort: MatSort = new MatSort();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  page = 0
  size = 10
  count = 0
  loading = false
  codeFilter = ''

  @ViewChild('existingCode', { static: false }) existingCode
  @ViewChild('addCode', { static: false }) addCode
  @ViewChild('addDate', { static: false }) addDate
  @ViewChild('filterInput', { static: false }) filterInput: any;

  clientId: any;
  clientParam = ''

  columnNames = [
    {
      id: "code",
      value: "Code",
    },
    {
      id: 'expected_users',
      value: 'Expected users'
    },
    {
      id: 'user_count',
      value: 'User count'
    },
    {
      id: 'completion',
      value: 'Completion'
    },

    {
      id: 'expected_completion',
      value: 'Expected completion date'
    },
    {
      id: 'expiry',
      value: 'Code expiry date'
    },
    {
      id: 'created',
      value: 'Created'
    },
    {
      id: 'content_last_updated',
      value: 'Training updated'
    }
  ];

  scheduleColumnNames = [
    {
      id: 'existing',
      value: 'Existing Code'
    },
    {
      id: 'add',
      value: 'Add code'
    },
    {
      id: 'onDate',
      value: 'Date'
    }
  ]

  scheduleDisplayedColumns = []

  constructor(private httpService: HttpService, private route: ActivatedRoute, private router: Router, public controller: ControllerService) {

  }

  async addAutoCode() {
    const existing = this.existingCode.nativeElement.value
    const add = this.addCode.nativeElement.value
    const date = this.addDate.nativeElement.value

    if (existing == add) {
      alert("Please select a different code to add.")
      return
    }
    if (!date) {
      alert("Please specify a date.")
      return
    }

    const resp = await this.httpService.postAsync('hcode/scheduleCode', {
      existingCode: existing,
      addCode: add,
      onDate: date,
    })

    if (!resp['success']) {
      if (resp['message'] == 'existing') {
        alert("This schedule already exists.")
      } else {
        alert("Your schedule could not be added at this time.")
      }
      return
    }

    await this.fetchSchedule()
  }

  async fetchSchedule() {

    this.scheduleDataSource = await this.httpService.postAsync('hcode/schedule', {
      clientId: this.clientId
    })
  }

  async removeSchedule(id) {
    await this.httpService.postAsync('hcode/remove', { id })
    await this.fetchSchedule()
  }

  skeletonRows: number[][] = [];

  generateSkeletonRows() {
    this.skeletonRows = Array(10).fill(0).map(() => {
      // Random number of bars between 5 and 8 to ensure density
      const barCount = Math.floor(Math.random() * (8 - 5 + 1)) + 5;
      const bars = [];
      for (let i = 0; i < barCount; i++) {
        // Random flex weight between 1 and 10 to give variety in width
        bars.push(Math.floor(Math.random() * 10) + 1);
      }
      return bars;
    });
  }

  async fetchCodes() {
    this.loading = false
    this.generateSkeletonRows(); // Generate new random rows on fetch
    try {
      const sort = {
        active: this.sort.active,
        direction: this.sort.direction
      }


      // Wait for both the API call and at least 1 second
      const [resp]: [any, any] = await Promise.all([
        this.httpService.postAsync("hcode/listCodes", { clientId: this.clientId, page: this.page, size: this.size, filter: this.codeFilter, sort }),
        new Promise(resolve => setTimeout(resolve, 0))
      ]);

      if (resp.success) {
        this.codes = resp.codes
        this.count = resp.count
      }

    } finally {
      this.loading = false
    }

    this.dataSource.data.length = 0
    this.dataSource.data = this.codes

    this.controller.setCodes(this.codes)
  }

  async onPaginateChange(event: PageEvent) {
    this.page = event.pageIndex;
    this.size = event.pageSize;
    await this.fetchCodes();
  }

  loadContent(codeId) {


    const code = this.codes.find(({ id }) => id == codeId)
    if (!this.clientParam) {

      const client = this.controller.getClientName(code.client_id)
      this.clientParam = this.controller.getClientNameAsParam(client)
    }

    if (!this.clientParam) {
      console.error(code)
      alert("Client not found")
      return
    }

    this.router.navigate([`client/${this.clientParam}/code/${code.code}`])
  }

  closeCodeDetail(event) {
    this.code = null

    if (event) {
      this.fetchCodes()
    }
  }

  newCode() {

    this.code = { 'description': '', active: true, clientId: this.clientId, contract_end_date: this.contractEndDate, kind: this.controller.getClientKind(this.clientId) }
  }

  editCode(codeId) {
    this.code = this.codes.find(({ id }) => id === codeId)
  }

  duplicatingCode: any = null
  duplicateTargetClientId: any = null
  duplicating = false
  duplicateClientSearchText = ''
  filteredDuplicateClients: any[] = []
  duplicatedCode: any = null
  duplicateError: string | null = null

  openDuplicateCode(codeId: any) {
    const code = this.codes.find(({ id }) => id === codeId)
    if (!code) {
      return
    }

    this.duplicatingCode = code
    this.duplicateTargetClientId = code.client_id ?? this.clientId
    this.duplicateError = null

    const clients = this.getDuplicateTargetClients()
    const selected = clients.find((c: any) => c.id === this.duplicateTargetClientId)
    this.duplicateClientSearchText = selected ? selected.name : ''
    this.filteredDuplicateClients = clients
  }

  closeDuplicateCode() {
    this.duplicatingCode = null
    this.duplicateTargetClientId = null
    this.duplicateClientSearchText = ''
    this.filteredDuplicateClients = []
    this.duplicateError = null
  }

  // Overlay/✕/Cancel route through here so a click can't dismiss the dialog
  // mid-request; confirmDuplicateCode calls closeDuplicateCode() directly to
  // close it once the request settles.
  dismissDuplicateCode() {
    if (this.duplicating) {
      return
    }
    this.closeDuplicateCode()
  }

  getDuplicateTargetClients(): any[] {
    return [...this.controller.getClients()].sort((a: any, b: any) => a.name.localeCompare(b.name))
  }

  filterDuplicateClients(search: string) {
    const term = (search || '').toLowerCase().trim()
    const clients = this.getDuplicateTargetClients()
    this.filteredDuplicateClients = term
      ? clients.filter((c: any) => c.name.toLowerCase().includes(term))
      : clients
  }

  onDuplicateClientSearchChange(value: string | any) {
    if (typeof value !== 'string') {
      // mat-autocomplete's ControlValueAccessor fires ngModelChange with the
      // selected client object before optionSelected; ignore it here, onDuplicateClientSelected handles it
      return
    }
    this.duplicateTargetClientId = null
    this.duplicateError = null
    this.filterDuplicateClients(value)
  }

  onDuplicateClientSelected(event: any) {
    const client = event.option.value
    this.duplicateTargetClientId = client.id
    this.duplicateClientSearchText = client.name
    this.duplicateError = null
  }

  displayDuplicateClient(client: any): string {
    if (typeof client === 'string') {
      return client
    }
    return client && client.name ? client.name : ''
  }

  async confirmDuplicateCode() {
    if (!this.duplicateTargetClientId || this.duplicating) {
      return
    }

    this.duplicating = true
    let didDuplicate = false
    try {
      const resp: any = await this.httpService.postAsync('hcode/duplicateCode', {
        id: this.duplicatingCode.id,
        clientId: this.duplicateTargetClientId
      })

      if (!resp['success']) {
        this.duplicateError = resp['message'] || "This code could not be duplicated at this time."
        return
      }

      this.closeDuplicateCode()
      this.duplicatedCode = resp['code']
      didDuplicate = true
    } catch (e) {
      this.duplicateError = "This code could not be duplicated at this time."
    } finally {
      this.duplicating = false
    }

    if (didDuplicate) {
      // Isolated from the duplicateError handling above: the duplicate already
      // succeeded, so a failed refresh here shouldn't surface as (or be
      // confused with) a duplicate failure on the next dialog.
      try {
        await this.fetchCodes()
      } catch (e) {
        console.error(e)
      }
    }
  }

  closeDuplicatedCode() {
    this.duplicatedCode = null
  }

  closeDuplicateError() {
    this.duplicateError = null
  }

  showSmartUrlCopied = false;

  copySmartURL(code) {
    const domain = window.location.hostname.indexOf('beta') > -1 ? 'beta' : 'learn'
    const url = `https://${domain}.hemisphereapp.io/start?activationCode=${code}`
    navigator['clipboard'].writeText(url)

    this.showSmartUrlCopied = code;
    setTimeout(() => {
      this.showSmartUrlCopied = false;
    }, 1500);
  }

  filter(event) {

    if (this.filterDebounce) {
      window.clearTimeout(this.filterDebounce)
    }

    this.page = 0

    this.filterDebounce = window.setTimeout(async () => {
      this.codeFilter = event.target.value.trim()
      this.controller.setCodeFilter(this.codeFilter)
      await this.fetchCodes()
    }, 250)
  }

  downloadUserGuide(code) {

    const url = this.controller.getUserGuideURL(code)

    window.open(url, "_blank")
  }

  async downloadGovernorsReport(code) {
    // Open the tab synchronously within the click gesture so the popup
    // blocker doesn't reject it after we await the (possibly refreshed) token.
    const win = window.open("", "_blank")
    const url = await this.controller.getGovernorsReportUrl(code)
    if (win) {
      win.location.href = url
    } else {
      window.open(url, "_blank")
    }
  }

  async fetchClients() {
    try {
      const clients = await this.httpService.postAsync("hclient/listClients", {})

      this.controller.setClients(clients)
    } catch (e) {
      if (e.status == 402) {
        this.controller.redirectToSignIn()
        return
      }
    }

  }

  async fetchLibrary(code) {
    const resp: any = await this.httpService.postAsync(
      "user/getLibraryForCode",
      { code },
    );
    if (resp.success) {
      this.library = resp.data;
    } else {
      alert(resp.message);
    }
  }

   async previewLibrary(code:string) {

    this.controller.flushLibrary();

    await this.fetchLibrary(code);

    this.controller.setPreviewing(true);

    await this.controller.fetchContents(this.library);

    this.controller.setupLibrary(false, code);
    this.controller.goToLibrary();
  }


  async ngOnInit() {
    const columns = this.columnNames.map(x => x.id)
    // Insert 'active' at index 1 (after 'code')
    columns.splice(1, 0, 'active')
    // Insert 'description' at index 2 (after 'active')
    columns.splice(2, 0, 'description')
    this.displayedColumns = columns.concat(['actions'])

    await this.fetchClients()


    const currentDate = new Date()
    this.fromDate = currentDate.toISOString().substring(0, 10);

    this.scheduleDisplayedColumns = this.scheduleColumnNames.map(x => x.id).concat(['remove'])
    this.dataSource = new MatTableDataSource(this.codes);

    this.sort.sortChange.subscribe(() => {
      this.page = 0
      this.fetchCodes()
    })

    this.controller.shiftContainerToTop()

    this.route.url.subscribe((url) => {
      if (url[0].path === 'client') {
        this.clientParam = url[1].path
        this.clientId = this.controller.getClientId(url[1].path)

        this.clientName = this.controller.getClientName(this.clientId)
        this.clientKind = this.controller.getClientKind(this.clientId)

        this.contractEndDate = this.controller.getClientExpiry(this.clientId)

        if (this.clientId == 1 && !this.displayedColumns.includes('stencil')) {
          this.displayedColumns.splice(1, 0, 'stencil')
        }
      }

      // Check if we're loading a specific code (url[3] would be the code value)
      // If so, clear the filter. Otherwise, restore it.
      if (url[3]) {
        // Specific code is being loaded, clear the filter
        this.codeFilter = ''
        this.controller.setCodeFilter('')
        // Use setTimeout to ensure ViewChild is initialized
        setTimeout(() => {
          if (this.filterInput && this.filterInput.nativeElement) {
            this.filterInput.nativeElement.value = ''
          }
        }, 0)
      } else {
        // No specific code, restore the filter
        this.codeFilter = this.controller.getCodeFilter()
        // Use setTimeout to ensure ViewChild is initialized
        setTimeout(() => {
          if (this.filterInput && this.filterInput.nativeElement) {
            this.filterInput.nativeElement.value = this.codeFilter
          }
        }, 0)
      }

      if (!this.clientId) {
        this.displayedColumns.splice(2, 0, 'client_name')
        this.fetchCodes()
        return
      }
      this.fetchCodes()
      this.fetchSchedule()
    })
  }

  showCsmReport(code, description) {
    this.displayCsmReport = code
    this.csmReportDescription = description
  }

  closeCsmReport(event) {
    this.displayCsmReport = false
  }

  shareUserguideToggle() {
    this.shareUserGuides = !this.shareUserGuides
  }

}
